import { useFlightStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreFlightsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { Dialog, DialogContent, DialogTrigger } from "@b2bportal/core-ui";
import { useI18nContext } from "@hopper-b2b/i18n";
import clsx from "clsx";
import defaultStyles from "./FareCombinationBanner.module.scss";
import InfoCta from "@/assets/icons/ui/info-cta.svg?react";

export interface FareCombinationBannerProps extends PlatformComponentProps {
  className?: string;
}

export const FareCombinationBanner = ({
  className,
}: FareCombinationBannerProps) => {
  const styles = useFlightStyles(
    CoreFlightsComponent.FareCombinationBanner,
    defaultStyles
  );

  const [block, cn] = useModuleBEM(
    styles,
    CoreFlightsComponent.FareCombinationBanner
  );

  const { t } = useI18nContext();

  return (
    <div className={clsx(block, className)}>
      <div className={cn("flight-combination-content")}>
        <div className={cn("flight-combination-copy")}>
          {t("combinationFlightWarning")}
        </div>
        <Dialog>
          <DialogTrigger
            className={cn("flight-combination-icon-trigger")}
            aria-label={t("learnMore")}
          >
            <InfoCta
              className={cn("flight-combination-icon")}
              aria-hidden="true"
              focusable="false"
            />
          </DialogTrigger>
          <DialogContent
            className={cn("flight-combination-dialog")}
            title={t("combinationFlightTitle")}
          >
            <div className={cn("flight-combination-description")}>
              {t("combinationFlightTooltip")}
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </div>
  );
};
